import React, { createContext, useState, useContext } from "react";

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const [openMenuId, setOpenMenuId] = useState(null);

  const openMenu = (id) => {
    setOpenMenuId(id);
  };

  const closeMenu = () => {
    setOpenMenuId(null);
  };

  return (
    <MenuContext.Provider value={{ openMenuId, openMenu, closeMenu }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error("useMenu must be used within a MenuProvider");
  }
  return context;
};
